'use client'

import styled from 'styled-components'
import { down, up } from 'styled-breakpoints'

export const UIStyledWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 3.125rem;

  ${down('md')} {
    margin-top: 2.5rem;
  }
`
export const UIStyledInner = styled.div`
  width: 100%;
  margin: 0 30px;
  ${up('xl')} {
    width: 1170px;
  }

  ${down('md')} {
    margin: 0;
    padding: 0 30px;
    overflow: hidden;
  }
`
